<template>
  <div
    class="relative w-full h-full"
    @touchstart="onTouchstart"
    @touchmove="onTouchmove"
    @touchend="onTouchend"
  >
    <svg
      version="2.0"
      viewBox="0 0 967.19 1610"
      xmlns="http://www.w3.org/2000/svg"
      class="uppercase menu w-full h-full"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="1571.9"
          x2="1659.6"
          y1="1079.9"
          y2="1006.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5d9db9" offset=".2" />
          <stop stop-color="#5891b3" offset="1" />
        </linearGradient>
      </defs>
      <g transform="translate(-1133.2 -489.87)">
        <g id="boundaries">
          <polygon
            id="polygon-top-tile-accent"
            fill="white"
            opacity="0.1"
            points="1616 542.89 1399.3 722.98 1616.8 980.01 1834.2 725.53"
          />
          <polygon
            id="polygon-top-tile"
            fill="white"
            opacity="0.1"
            points="1616 597.62 1399.3 777.71 1616.8 1039.7 1834.2 780.26"
          />
          <g id="polygon-thick" fill="none" opacity="0.1">
            <path
              fill="white"
              d="m1616.8 597.52 459.58 389.9v605.88l-459.58 385.56-459.58-385.56v-605.88l459.58-389.9m0-31.47-15.53 13.17-459.58 389.9-8.47 7.19v628.19l468.15 392.75 15.43 12.94 15.43-12.94 468.15-392.75v-628.19l-8.47-7.19-459.58-389.9z"
            />
          </g>
          <g id="polygon-slim" fill="none" opacity="0.2">
            <path
              fill="white"
              d="m1616.2 598.29 459.58 389.9v605.88l-459.58 385.56-459.58-385.56v-605.88l459.58-389.9m0-7.87-3.88 3.29-459.58 389.9-2.12 1.8v611.46l2.14 1.8 459.58 385.56 3.86 3.24 3.86-3.24 459.58-385.56 2.14-1.8v-611.46l-2.12-1.8-459.58-389.9z"
            />
          </g>
        </g>
        <g id="shape" :class="interactiveClasses">
          <g id="shape">
            <polygon
              id="poligon-outline-bottom"
              fill="white"
              opacity="0.1"
              points="1615.8 1957.6 1178.8 1592.9 1152 1596.8 1616.5 1988 2081.8 1596.2 2051.5 1595.6"
            />
            <polygon
              id="overlay-right"
              fill="white"
              opacity="0.1"
              points="1616.8 1540.8 2075 986.95 2075.3 1596.6 1830.5 1798.8"
            />
            <polygon
              id="overlay-left"
              fill="white"
              opacity="0.1"
              points="1616.8 1540.8 1157.9 985.9 1157.6 1595.5 1401.6 1799.2"
            />
            <polygon
              id="system-outline-top"
              fill="white"
              opacity="0.1"
              points="1616.8 1070.3 1178.8 1592.9 1150.6 1596.2 1616.8 1039.7 2082.2 1596.1 2051.5 1595.6"
            />
          </g>
          <g id="system">
            <g id="council-states" :class="{ hidden: disableBottomRight }">
              <path
                fill="#f2f2f2"
                d="m1821.7 1484.2c3.67 0.37 7.36 0.69 10.87 1.97 3.1 1.13 6.01 2.6 8.71 4.52 3.25 2.3 5.99 5.12 8.5 8.16 0.95 1.15 1.78 2.42 2.5 3.72 0.64 1.15-0.6 1.47-1.22 1.8-0.74 0.41-1.48 0.84-2.2 1.28-1.04 0.65-1.69 0.43-2.28-0.64-1.26-2.33-3.16-4.15-4.99-6.04-1.93-1.98-4.11-3.62-6.58-4.8-1.97-0.93-3.92-1.91-6.08-2.46-2.58-0.65-5.12-1.33-7.81-1.36-0.65 0-0.84-0.49-0.84-1.05 0-1.32-0.02-2.63 0.01-3.96 0.02-0.87 0.52-1.26 1.38-1.15z"
              />
              <path
                fill="#f2f2f2"
                d="m1816.7 1487.3c-0.04 2.95-0.05 2.82-2.99 3.19-1.69 0.22-3.4 0.51-5.06 1.08-1.39 0.48-2.8 0.9-4.15 1.49-2.05 0.9-3.98 1.98-5.8 3.29-2.88 2.08-5.35 4.57-7.31 7.53-0.32 0.48-0.64 0.95-0.91 1.48-0.4 0.81-1.35 0.6-1.94 0.3-1.12-0.58-2.26-1.11-3.31-1.83-0.68-0.47-0.65-0.93-0.29-1.48 1.46-2.28 3.08-4.43 5-6.37 1.57-1.57 3.09-3.18 4.86-4.51 2.41-1.81 4.97-3.44 7.77-4.55 3.41-1.36 6.94-2.3 10.64-2.48 0.75-0.04 1.5-0.19 2.26-0.27 0.87-0.09 1.24 0.35 1.22 1.19-0.01 0.65 0 1.29 0 1.94z"
              />
              <path
                fill="#f2f2f2"
                d="m1797.1 1479.1c1.44-0.22 1.36 1.1 1.83 1.79 0.41 0.61 0.51 1.44 0.95 2.02 0.84 1.12-0.2 1.55-0.76 1.84-1.77 0.93-3.46 1.95-5.14 3.04-3.97 2.58-7.14 5.98-10.03 9.66-0.72 0.91-1.28 1.95-1.85 2.97-0.48 0.86-1.15 1.03-2.35 0.39-1.05-0.57-2.08-1.19-3.11-1.82-0.54-0.33-0.56-0.82-0.24-1.31 1.82-2.82 3.86-5.47 6.06-7.99 2.4-2.75 5.19-5.06 8.21-7.13 1.35-0.92 2.71-1.83 4.14-2.59 0.7-0.37 1.36-1.12 2.28-0.88z"
              />
              <path
                fill="#f2f2f2"
                d="m1839.9 1479.1c0.96-0.19 1.65 0.46 2.33 0.82 1.9 1.01 3.78 2.13 5.47 3.46 2.08 1.64 4.14 3.32 6.01 5.21 2.09 2.1 3.7 4.55 5.47 6.88 0.55 0.72 0.93 1.57 1.51 2.29 0.37 0.46 0.14 0.98-0.37 1.28-1.32 0.78-2.6 1.64-3.99 2.27-0.63 0.28-1.08-0.48-1.41-1.01-2.02-3.33-4.22-6.56-7.24-9.04-2.21-1.81-4.38-3.7-6.96-5.02-0.95-0.49-1.83-1.1-2.85-1.5-0.86-0.34-1-1.48-0.26-2.56 0.5-0.73 0.65-1.58 1.1-2.33 0.31-0.51 0.54-0.9 1.17-0.74v-0.02z"
              />
              <path
                fill="#f2f2f2"
                d="m1871.9 1517.4c-0.3-1.48-0.7-3.4-1.08-5.31-0.37-1.89-1.05-3.67-1.78-5.44-0.74-1.8-1.34-3.68-2.47-5.31-0.56-0.82-0.3-1.46 0.61-1.9 1.13-0.54 2.21-1.19 3.28-1.85 0.65-0.39 1.2-0.44 1.49 0.34 0.47 1.29 1.21 2.46 1.74 3.72 0.39 0.91 0.63 1.88 1.03 2.79 0.83 1.88 1.52 3.85 2.04 5.84 0.56 2.09 0.95 4.23 1.24 6.37 0.2 1.56-0.82 2.54-2.39 2.58-0.62 0.02-1.24 0-1.85 0.11-1.62 0.26-1.85 0.08-1.88-1.94z"
              />
              <path
                fill="#f2f2f2"
                d="m1759.8 1516.1c-0.04-2.19 0.38-4.28 0.99-6.39 0.31-1.08 0.65-2.17 0.89-3.29 0.17-0.81 0.59-1.55 0.9-2.32 0.8-2 1.78-3.93 2.68-5.9 0.45-0.98 0.84-1.02 1.81-0.48 1.1 0.61 2.14 1.33 3.33 1.8 0.85 0.33 0.75 1.17 0.41 1.72-1.22 2.04-2.04 4.21-2.83 6.43-1.28 3.56-2.16 7.19-2.66 10.92-0.09 0.7-0.54 0.96-1.12 0.83-1.19-0.25-2.4-0.18-3.6-0.26-0.63-0.04-0.83-0.3-0.8-0.89 0.03-0.73 0-1.46 0-2.19z"
              />
              <path
                fill="#f2f2f2"
                d="m1868.5 1518.6c0.24 1.03-0.18 1.43-1.24 1.38-1.13-0.05-2.2 0.41-3.31 0.56-0.91 0.13-1.83-0.59-1.81-1.49 0.04-2.24-0.74-4.3-1.31-6.42-0.64-2.44-1.67-4.7-2.9-6.89-0.27-0.48-0.22-1.03 0.41-1.35 1.16-0.59 2.32-1.18 3.44-1.85 0.95-0.57 1.47-0.39 1.89 0.62 0.52 1.24 1.12 2.44 1.74 3.63 0.38 0.72 0.53 1.52 0.8 2.26 0.7 1.95 1.43 3.91 1.64 6.01 0.12 1.19 0.77 2.29 0.65 3.55z"
              />
              <path
                fill="#f2f2f2"
                d="m1768.6 1518.7c0.51-1.83 0.76-3.71 1.2-5.56 0.44-1.87 1.17-3.63 1.72-5.46 0.4-1.31 1.11-2.54 1.68-3.8 0.01-0.02 0.04-0.04 0.06-0.06 0.5-0.53 0.23-1.76 1.48-1.61 0.82 0.1 1.32 0.78 2.06 1.06 0.72 0.27 1.31 0.82 2.05 1.11 0.86 0.33 0.66 1.05 0.3 1.61-0.92 1.41-1.32 3.03-2.01 4.52-0.86 1.85-1.17 3.86-1.87 5.75-0.25 0.68-0.2 1.49-0.23 2.24-0.07 1.71-0.82 2.3-2.49 1.89-1.01-0.25-2.02-0.48-3.07-0.46-0.89 0.01-0.86-0.6-0.87-1.24z"
              />
              <path
                fill="#f2f2f2"
                d="m1869.2 1493.5c0.06 0.63-0.05 0.93-0.35 1.08-1.27 0.63-2.48 1.37-3.7 2.1-0.52 0.31-1.23 0.19-1.53-0.45-1.61-3.43-4.12-6.2-6.5-9.06-0.7-0.85-1.67-1.43-2.2-2.49-0.41-0.82-0.18-1.34 0.32-1.87 0.77-0.81 1.55-1.6 2.21-2.52 0.41-0.58 0.79-0.64 1.33-0.04 1.66 1.82 3.54 3.43 5.07 5.37 1.29 1.64 2.63 3.26 3.72 5.03 0.62 0.99 1.41 1.95 1.62 2.86z"
              />
              <path
                fill="#f2f2f2"
                d="m1772.4 1496.8c-0.84-0.47-1.87-1.02-2.87-1.61-0.31-0.18-0.59-0.4-0.95-0.51-0.65-0.2-0.85-0.75-0.53-1.26 1.3-2.06 2.54-4.15 4.03-6.11 1.9-2.5 4.01-4.79 6.22-7.02 0.58-0.59 0.93-0.57 1.4 0.05 0.84 1.12 1.84 2.1 2.88 3.04 0.46 0.41 0.56 0.87 0.06 1.29-2.56 2.16-4.62 4.77-6.61 7.43-0.95 1.26-1.83 2.63-2.38 4.16-0.18 0.5-0.58 0.55-1.24 0.55z"
              />
              <path
                fill="#f2f2f2"
                d="m1855.7 1521.3c-0.14 0-0.28 0.02-0.42 0.02-2.13 0.08-2.08 0.08-2.53-2-0.5-2.33-1.09-4.65-2.08-6.82-0.3-0.64-0.59-1.34-1.02-1.96-0.74-1.07 0.44-1.49 1-1.79 0.65-0.34 1.25-0.79 1.95-1.1 1.89-0.84 2.47-0.59 3.29 1.28 1 2.26 1.88 4.56 2.55 6.93 0.37 1.3 0.56 2.67 0.82 4 0.15 0.79-0.77 1.22-1.54 1.32-0.66 0.08-1.34 0.02-2.02 0.02v0.11z"
              />
              <path
                fill="#f2f2f2"
                d="m1782.5 1521.4c-1.05-0.07-2.11-0.12-3.18-0.22-0.85-0.08-1.12-0.48-1.05-1.42 0.13-1.76 0.6-3.46 0.97-5.16 0.22-1.02 0.62-2 1.01-2.98 0.48-1.2 0.99-2.37 1.59-3.52 0.41-0.78 1.31-1.19 2.14-0.72 1.1 0.63 2.17 1.31 3.25 1.96 0.44 0.27 0.6 0.72 0.33 1.08-0.82 1.1-1.24 2.39-1.75 3.62-0.39 0.96-0.74 2.01-0.86 3.03-0.14 1.24-0.56 2.4-0.7 3.63-0.14 1.19-1.13 0.54-1.77 0.72z"
              />
              <path
                fill="#f2f2f2"
                d="m1810 1540.4c0.03 3.27 0.34 2.82-2.94 2.8-2.17-0.01-4.27-0.44-6.37-0.84-1.48-0.27-2.95-0.81-4.29-1.5-0.71-0.37-0.39-1.4-0.15-2.09 0.34-1.02 0.79-2 1.23-2.99 0.34-0.79 1.09-0.72 1.55-0.36 0.96 0.74 2.16 0.84 3.2 1.07 1.99 0.44 3.98 1.09 6.11 0.89 1.52-0.14 1.74 0.19 1.67 1.75-0.01 0.42 0 0.84 0 1.26z"
              />
              <path
                fill="#f2f2f2"
                d="m1831.1 1543.1c-1.13 0.06-1.89 0.08-2.64 0.15s-1.12-0.25-1.12-0.99c0-1.26-0.01-2.52-0.01-3.79 0-0.78 0.36-1.24 1.19-1.13 2.22 0.3 4.34-0.38 6.44-0.85 1.03-0.23 2.21-0.39 3.19-1.09 0.56-0.41 1.34-0.41 1.62 0.61 0.19 0.69 0.52 1.34 0.82 1.99 0.98 2.12 0.43 3.23-1.85 3.68-1.54 0.3-3.06 0.76-4.57 1.16-1.13 0.3-2.29 0.12-3.06 0.25z"
              />
              <path
                fill="#f2f2f2"
                d="m1818.5 1533.8h-3.28c-0.78 0-1.54-0.77-1.52-1.55 0.01-0.93 0.04-1.85 0.02-2.78-0.03-1.29 0.58-1.84 1.84-1.82 2.07 0.04 4.15 0.01 6.23-0.02 0.91-0.01 1.63 0.68 1.59 1.6-0.04 0.9-0.06 1.8-0.02 2.69 0.05 1.26-0.55 1.88-1.83 1.84-1.01-0.03-2.02 0-3.03 0v0.03z"
              />
              <path
                fill="#f2f2f2"
                d="m1818.5 1543.3c-1.15 0-2.3-0.02-3.45 0-0.93 0.02-1.41-0.31-1.36-1.33 0.06-1.12 0.02-2.24 0-3.37-0.01-0.86 0.34-1.33 1.25-1.28 2.38 0.13 4.76 0.13 7.15 0 0.89-0.05 1.29 0.4 1.29 1.26v3.62c0 0.88-0.53 1.1-1.26 1.1h-3.62z"
              />
              <path
                fill="#f2f2f2"
                d="m1818.5 1547.2c1.18 0 2.36 0.03 3.53 0 0.92-0.03 1.36 0.36 1.35 1.29-0.01 1.07 0 2.14 0 3.2-0.01 1.13-0.48 1.44-1.59 1.33-2.15-0.21-4.32-0.22-6.47 0-1.19 0.12-1.63-0.17-1.63-1.36 0-1.07 0.02-2.14 0-3.2-0.02-0.9 0.38-1.27 1.27-1.25 1.18 0.04 2.36 0 3.53 0z"
              />
              <path
                fill="#f2f2f2"
                d="m1806.4 1552.9c-1.71 0.19-3.32-0.42-4.98-0.67-0.39-0.06-0.63-0.34-0.58-0.71 0.18-1.07 0.03-2.21 0.58-3.2 0.06-0.1 0.1-0.2 0.13-0.31 0.52-1.69 0.52-1.68 2.35-1.43 1.69 0.23 3.4 0.42 5.1 0.62 0.44 0.05 0.94 0.13 0.95 0.64 0.01 1.34 0.02 2.69-0.15 4.02-0.11 0.84-0.82 1.17-1.71 1.05-0.56-0.08-1.12-0.01-1.69-0.01z"
              />
              <path
                fill="#f2f2f2"
                d="m1830.6 1552.9h-2.19c-0.7 0-1.03-0.35-1.03-1.03v-3.61c0-0.51 0.13-0.97 0.74-1.04 2.14-0.25 4.28-0.48 6.42-0.74 0.63-0.08 0.8 0.23 1.04 0.79 0.55 1.26 0.51 2.62 0.89 3.89 0.16 0.54 0.03 0.99-0.58 1.08-1.76 0.25-3.49 0.87-5.31 0.67z"
              />
            </g>
            <g id="Nationalrat" :class="{ hidden: disableBottomLeft }">
              <path
                fill="#f2f2f2"
                d="m1414.1 1443.6v1.8c0 1.16-0.19 1.32-1.33 1.37-2.33 0.1-4.67 0.15-6.99 0.39-2.06 0.21-4.11 0.59-6.14 1.03-2.5 0.53-4.99 1.12-7.44 1.83-1.68 0.48-3.32 1.17-4.93 1.85-2.37 1-4.76 1.98-7.05 3.14-2.07 1.04-4.09 2.23-6.02 3.5-2.32 1.53-4.55 3.21-6.82 4.83-0.23 0.16-0.39 0.42-0.62 0.58-0.5 0.34-0.99 0.37-1.43-0.15-0.93-1.11-1.88-2.2-2.81-3.32-0.39-0.46-0.56-0.97 0-1.41 1.72-1.35 3.39-2.77 5.2-4 2.47-1.67 4.99-3.27 7.58-4.73 2.21-1.25 4.51-2.37 6.84-3.37 2.15-0.93 4.38-1.67 6.6-2.42 2.01-0.68 4.04-1.33 6.1-1.87 1.5-0.39 3.06-0.62 4.6-0.87 1.85-0.3 3.71-0.58 5.58-0.8 1.64-0.19 3.29-0.31 4.93-0.45 1.02-0.08 2.05-0.12 3.07-0.16 0.75-0.03 1.1 0.35 1.09 1.09v2.14z"
              />
              <path
                fill="#f2f2f2"
                d="m1418 1443.5v-2.05c0-0.7 0.31-1.1 1.03-1.06 2.39 0.13 4.78 0.21 7.16 0.44 2.35 0.24 4.68 0.61 7 0.98 1.43 0.24 2.84 0.56 4.25 0.91 1.6 0.39 3.19 0.81 4.76 1.27 1 0.29 1.98 0.68 2.95 1.06 1.39 0.54 2.78 1.08 4.15 1.67 1.48 0.63 2.94 1.29 4.38 2 1.5 0.73 2.97 1.52 4.42 2.33 3.52 1.98 6.88 4.19 9.94 6.84 0.43 0.37 0.89 0.71 1.35 1.03 0.58 0.41 0.68 0.97 0.2 1.51-0.98 1.13-1.98 2.27-2.97 3.39-0.42 0.48-0.88 0.41-1.35 0.05-2.71-2.01-5.34-4.14-8.16-5.97-2.25-1.46-4.72-2.57-7.11-3.81-1.25-0.65-2.52-1.31-3.83-1.84-1.54-0.63-3.14-1.12-4.71-1.66-0.75-0.26-1.5-0.51-2.26-0.73-1.33-0.39-2.66-0.81-4.01-1.14-1.33-0.33-2.66-0.61-4.01-0.83-3.93-0.67-7.89-1.08-11.88-1.12-1.08-0.01-1.3-0.23-1.3-1.3z"
              />
              <path
                fill="#f2f2f2"
                d="m1409.7 1450.8h3.24c0.96 0 1.18 0.22 1.19 1.14 0.01 1.34 0 2.68 0 4.01 0 0.74-0.29 1.1-1.06 1.1-1 0-2 0.04-2.99 0.11-4.16 0.26-8.28 0.77-12.27 2.02-2.67 0.84-5.31 1.8-7.96 2.7-3.27 1.11-6.27 2.77-9.17 4.58-2.57 1.61-4.94 3.52-7.39 5.3-0.51 0.38-0.96 0.33-1.35-0.13-0.98-1.13-1.96-2.28-2.92-3.44-0.35-0.43-0.36-0.95 0.11-1.29 2.4-1.75 4.78-3.54 7.25-5.2 1.73-1.17 3.56-2.22 5.41-3.19 1.73-0.91 3.53-1.66 5.33-2.43 1.33-0.57 2.67-1.13 4.05-1.54 2.64-0.79 5.28-1.61 7.97-2.17 3.47-0.71 7-1.16 10.5-1.73l0.04 0.14h0.02z"
              />
              <path
                fill="#f2f2f2"
                d="m1418 1453.9v-1.97c0.02-0.91 0.24-1.12 1.22-1.11 3.39 0.04 6.79 0.17 10.12 0.86 3.17 0.65 6.36 1.32 9.46 2.24 2.79 0.83 5.55 1.85 8.21 3.04 4.28 1.91 8.29 4.34 12.11 7.05 1.28 0.91 2.48 1.9 3.71 2.87 0.5 0.39 0.5 0.86 0.1 1.33-0.95 1.13-1.89 2.27-2.85 3.4-0.41 0.48-0.88 0.61-1.4 0.14-2.6-2.27-5.43-4.22-8.41-5.93-2.25-1.3-4.56-2.52-6.94-3.57-2.17-0.95-4.47-1.63-6.72-2.38-5.67-1.9-11.52-2.71-17.48-2.79-0.78 0-1.16-0.34-1.13-1.14 0.02-0.68 0-1.37 0-2.05z"
              />
              <path
                fill="#f2f2f2"
                d="m1483.9 1509.1c-0.53-0.02-0.85-0.45-1.01-1.16-0.33-1.43-0.66-2.87-1.12-4.26-0.53-1.62-1.13-3.21-1.78-4.78-0.54-1.3-1.17-2.57-1.81-3.81-0.75-1.45-1.48-2.93-2.36-4.31-1.33-2.07-2.63-4.19-4.19-6.08-2.27-2.76-4.77-5.34-7.19-7.99-0.38-0.41-0.85-0.76-1.29-1.11-0.61-0.48-0.68-1.01-0.17-1.59 0.93-1.07 1.87-2.14 2.81-3.21 0.51-0.58 0.97-0.62 1.51-0.06 2.41 2.49 4.81 5 7.2 7.5 2.27 2.37 4.06 5.11 5.78 7.89 1.13 1.83 2.29 3.64 3.33 5.51 0.68 1.23 1.18 2.55 1.75 3.84 0.62 1.43 1.25 2.84 1.8 4.29 0.4 1.06 0.67 2.16 0.99 3.24 0.34 1.13 0.61 2.28 1.03 3.39 0.24 0.63 0.19 1.03-0.43 1.31-0.44 0.19-0.87 0.42-1.33 0.55-1.09 0.29-2.19 0.53-3.49 0.85z"
              />
              <path
                fill="#f2f2f2"
                d="m1348 1509.1c-1.58-0.48-3.15-0.94-4.7-1.46-0.5-0.17-0.58-0.59-0.42-1.13 0.39-1.29 0.66-2.61 1.06-3.89 0.31-1 0.71-1.96 1.09-2.94 0.29-0.76 0.61-1.51 0.91-2.27 1.13-2.99 2.48-5.88 4.17-8.58 1.48-2.38 2.96-4.78 4.61-7.04 1.42-1.95 3.02-3.76 4.65-5.54 1.68-1.84 3.5-3.57 5.25-5.34 0.76-0.77 1.1-0.77 1.8 0.04 0.93 1.07 1.85 2.15 2.79 3.23 0.46 0.53 0.31 0.93-0.15 1.39-2.35 2.35-4.81 4.61-6.97 7.13-2.01 2.33-3.79 4.88-5.48 7.47-1.26 1.93-2.24 4.05-3.28 6.12-0.65 1.28-1.23 2.61-1.78 3.94-0.39 0.96-0.68 1.98-1.01 2.97-0.32 0.94-0.68 1.87-0.97 2.82-0.19 0.65-0.32 1.32-0.43 1.99-0.11 0.69-0.45 1.08-1.14 1.13z"
              />
              <path
                fill="#f2f2f2"
                d="m1414.1 1464.2v2.14c0 0.68-0.32 1.06-1.03 1.09-1.82 0.09-3.64 0.2-5.45 0.31-0.4 0.02-0.8 0.04-1.19 0.12-2.22 0.45-4.48 0.81-6.67 1.4-1.79 0.48-3.53 1.18-5.25 1.88-1.8 0.73-3.61 1.48-5.33 2.37-2.94 1.53-5.77 3.27-8.34 5.39-0.42 0.35-0.96 0.69-1.47 0.74-0.38 0.04-0.9-0.31-1.2-0.63-0.85-0.91-1.61-1.91-2.42-2.86-0.44-0.51-0.42-1.05 0.15-1.45 2.64-1.87 5.22-3.84 7.96-5.54 2-1.24 4.22-2.17 6.37-3.16 1.53-0.71 3.1-1.35 4.68-1.93 1.11-0.4 2.28-0.64 3.43-0.93 1.23-0.31 2.48-0.56 3.71-0.87 3.53-0.88 7.14-1.06 10.75-1.2 1.19-0.05 1.3 0.11 1.3 1.33z"
              />
              <path
                fill="#f2f2f2"
                d="m1418 1464.2v-1.88c0-1.03 0.21-1.26 1.27-1.23 1.3 0.03 2.62 0.04 3.92 0.2 2.22 0.27 4.45 0.61 6.66 0.98 1.53 0.26 3.06 0.58 4.57 0.97 1.06 0.27 2.1 0.68 3.13 1.05 0.88 0.31 1.75 0.65 2.61 1.01 1.35 0.56 2.75 1.04 4.04 1.73 2.32 1.25 4.61 2.56 6.83 3.97 1.48 0.94 2.83 2.08 4.24 3.14 0.25 0.19 0.51 0.36 0.76 0.54 0.61 0.45 0.64 0.94 0.16 1.5-0.85 0.99-1.69 2-2.5 3.02-0.71 0.89-1.13 0.88-2.05 0.2-2.15-1.58-4.29-3.17-6.57-4.56-2.04-1.25-4.2-2.32-6.38-3.31-1.59-0.71-3.3-1.15-4.96-1.7-0.78-0.26-1.55-0.51-2.35-0.7-1.58-0.37-3.14-0.81-4.74-1.02-2.34-0.31-4.69-0.5-7.04-0.64-1.45-0.09-1.6-0.16-1.6-1.64z"
              />
              <path
                fill="#f2f2f2"
                d="m1372.2 1478.1c0.34 0.25 0.68 0.41 0.9 0.68 0.93 1.08 1.83 2.18 2.72 3.29 0.45 0.56 0.19 1-0.27 1.39-2.79 2.33-5.24 4.99-7.36 7.92-1.66 2.29-3.19 4.7-4.58 7.15-0.96 1.68-1.55 3.57-2.4 5.32-1.03 2.14-1.63 4.39-2.13 6.7-0.13 0.61-0.56 0.89-1.13 0.78-1.37-0.28-2.74-0.56-4.07-0.95-0.84-0.25-1.09-1.02-0.83-1.88 0.56-1.82 0.98-3.69 1.68-5.45 0.96-2.42 2.03-4.8 3.23-7.11 1.12-2.16 2.32-4.3 3.74-6.27 1.75-2.45 3.7-4.76 5.68-7.03 1.2-1.4 2.6-2.62 3.93-3.91 0.24-0.23 0.54-0.36 0.9-0.6z"
              />
              <path
                fill="#f2f2f2"
                d="m1473.9 1511.4c-0.23-0.25-0.66-0.51-0.79-0.89-0.39-1.16-0.62-2.36-0.98-3.53-0.31-1-0.66-1.98-1.07-2.94-0.51-1.2-1.03-2.38-1.63-3.53-1.05-2-2.07-4.02-3.26-5.94-2.45-4-5.55-7.47-9.01-10.65-0.19-0.17-0.4-0.32-0.59-0.48-0.63-0.52-0.66-0.93-0.12-1.58 0.81-0.98 1.62-1.98 2.42-2.97 0.72-0.89 1.25-0.96 2.04-0.11 2.61 2.77 5.35 5.43 7.71 8.41 2.01 2.54 3.69 5.38 5.28 8.21 1.3 2.31 2.36 4.77 3.34 7.24 0.81 2.02 1.38 4.16 2 6.25 0.25 0.84-0.53 1.25-1.05 1.43-1.31 0.46-2.7 0.69-4.29 1.08z"
              />
              <path
                fill="#f2f2f2"
                d="m1466.3 1519.1c-1.96 0.05-1.95 0.04-2.22-1.39-0.37-1.92-0.62-3.88-1.2-5.73-0.71-2.29-1.55-4.56-2.62-6.7-1.23-2.48-2.64-4.9-4.2-7.19-1.76-2.59-3.97-4.83-6.35-6.87-0.52-0.44-0.53-0.96-0.07-1.46 0.86-0.94 1.72-1.9 2.5-2.89 0.79-1.01 1.11-1.08 2-0.19 1.7 1.72 3.51 3.36 5.04 5.21 1.64 1.98 3.14 4.11 4.48 6.3 1.23 1.99 2.22 4.13 3.2 6.26 0.75 1.63 1.49 3.29 1.93 5.02 0.66 2.6 1.11 5.26 1.55 7.91 0.17 1.02-0.12 1.27-1.12 1.38-1.13 0.13-2.26 0.26-2.94 0.34z"
              />
              <path
                fill="#f2f2f2"
                d="m1365.7 1519.1c-0.83-0.1-2.02-0.23-3.21-0.38-0.61-0.08-0.93-0.42-0.86-1.04 0.11-0.96 0.19-1.93 0.38-2.87 0.35-1.72 0.72-3.43 1.18-5.12 0.28-1.03 0.74-2 1.12-2.99 0.28-0.73 0.52-1.49 0.86-2.2 1.04-2.13 2.05-4.28 3.22-6.34 0.89-1.57 1.9-3.11 3.07-4.48 1.98-2.34 4.12-4.54 6.2-6.79 0.14-0.15 0.29-0.28 0.42-0.42 0.56-0.56 1.07-0.51 1.58 0.09 0.91 1.09 1.83 2.16 2.77 3.23 0.42 0.48 0.33 1.01-0.14 1.48-1.78 1.79-3.64 3.51-5.23 5.45-1.55 1.9-2.92 3.99-4.14 6.12-0.99 1.73-1.68 3.64-2.46 5.49-0.43 1.03-0.85 2.09-1.18 3.16-0.34 1.08-0.61 2.18-0.84 3.29-0.19 0.92-0.28 1.85-0.45 2.78-0.29 1.59-0.31 1.59-2.26 1.55z"
              />
              <path
                fill="#f2f2f2"
                d="m1414.1 1474.6v2.22c0 0.62-0.28 0.91-0.93 0.96-2.49 0.22-5.01 0.34-7.46 0.78-2.17 0.4-4.28 1.13-6.38 1.82-1.53 0.5-3.07 1.05-4.48 1.8-2.15 1.15-4.2 2.47-6.27 3.76-0.67 0.42-1.25 0.98-1.85 1.49-0.53 0.44-1.01 0.46-1.48-0.09-0.96-1.12-1.92-2.25-2.89-3.36-0.46-0.53-0.41-0.98 0.14-1.37 2.35-1.64 4.64-3.36 7.07-4.86 1.55-0.96 3.27-1.66 4.96-2.37 1.67-0.7 3.37-1.35 5.11-1.86 1.93-0.56 3.91-1.06 5.9-1.36 2.39-0.37 4.81-0.55 7.22-0.74 1.16-0.09 1.35 0.16 1.35 1.3v1.88z"
              />
              <path
                fill="#f2f2f2"
                d="m1418 1474.5c0-0.68 0.01-1.37 0-2.05-0.03-0.81 0.37-1.17 1.15-1.11 1.96 0.16 3.93 0.23 5.87 0.53 2.25 0.35 4.49 0.78 6.67 1.4 2.17 0.62 4.28 1.49 6.38 2.33 1.28 0.51 2.55 1.09 3.72 1.81 2.11 1.31 4.14 2.75 6.21 4.14 0.47 0.32 0.93 0.65 1.4 0.98 0.55 0.39 0.64 0.84 0.21 1.37-0.94 1.13-1.9 2.26-2.84 3.39-0.46 0.56-0.95 0.53-1.47 0.09-2.25-1.94-4.7-3.59-7.4-4.8-2.68-1.2-5.39-2.39-8.19-3.28-3.37-1.08-6.88-1.58-10.43-1.58-1.18 0-1.28-0.11-1.28-1.25z"
              />
              <path
                fill="#f2f2f2"
                d="m1339.5 1486.2c0.4-0.67 0.71-1.2 1.03-1.73 1.09-1.75 2.13-3.54 3.28-5.25 3.92-5.86 8.36-11.27 13.73-15.88 0.21-0.19 0.41-0.39 0.61-0.59 0.55-0.52 1.12-0.44 1.58 0.14 0.86 1.08 1.75 2.15 2.65 3.22 0.53 0.63 0.46 1.11-0.15 1.65-1.5 1.34-3.03 2.66-4.38 4.14-2.15 2.34-4.25 4.73-6.22 7.22-1.43 1.82-2.66 3.81-3.91 5.76-0.81 1.25-1.51 2.59-2.27 3.88-0.29 0.48-0.94 0.51-1.5 0.19-1.23-0.69-2.49-1.32-3.71-2-0.26-0.15-0.46-0.44-0.74-0.73z"
              />
              <path
                fill="#f2f2f2"
                d="m1487.3 1489.3c-0.24-0.2-0.57-0.35-0.73-0.61-1.19-1.93-2.27-3.91-3.53-5.8-1.43-2.15-2.85-4.33-4.55-6.25-2.56-2.89-5.31-5.62-8.06-8.34-1.16-1.14-1.83-1.08-0.13-2.81 0.66-0.67 1.24-1.42 1.78-2.18 0.5-0.71 1.12-0.78 1.78-0.42 0.54 0.29 1.05 0.7 1.48 1.13 2.96 2.95 6.02 5.81 8.49 9.22 1.83 2.52 3.73 5 5.51 7.56 0.88 1.27 1.58 2.68 2.35 4.03 0.09 0.15 0.16 0.31 0.26 0.43 0.78 0.95 0.64 1.32-0.51 1.87s-2.23 1.23-3.35 1.83c-0.22 0.12-0.46 0.19-0.81 0.34z"
              />
              <path
                fill="#f2f2f2"
                d="m1460.2 1518.8c0.04 0.69-0.23 1.03-0.96 1.11-1.24 0.14-2.47 0.36-3.71 0.58-0.96 0.18-1.32 0-1.53-0.96-0.36-1.58-0.64-3.19-1.06-4.75-0.29-1.09-0.73-2.14-1.13-3.2-0.3-0.79-0.53-1.63-0.97-2.34-1.28-2.1-2.52-4.24-4-6.19-1.12-1.48-2.6-2.68-3.9-4.04-0.46-0.48-0.31-0.99 0.09-1.45 0.95-1.09 1.9-2.18 2.84-3.27 0.42-0.48 0.94-0.5 1.38-0.02 1.83 1.99 3.7 3.93 5.45 5.99 0.96 1.14 1.75 2.44 2.52 3.73 0.76 1.28 1.48 2.61 2.08 3.98 0.55 1.24 1.01 2.54 1.36 3.84 0.63 2.3 1.16 4.63 1.73 6.94l-0.2 0.05z"
              />
              <path
                fill="#f2f2f2"
                d="m1371.9 1518.8c0.26-1.43 0.43-2.88 0.81-4.27 0.57-2.1 1.14-4.24 1.99-6.24 0.83-1.97 1.99-3.81 3.07-5.66 0.6-1.03 1.26-2.03 2.04-2.93 1.6-1.85 3.27-3.64 4.93-5.42 0.57-0.61 1.02-0.52 1.55 0.13 0.87 1.05 1.76 2.07 2.67 3.09 0.5 0.56 0.5 1.13-0.08 1.62-2.24 1.88-4.09 4.09-5.6 6.6-0.89 1.48-1.83 2.94-2.53 4.5-0.68 1.52-1.17 3.14-1.61 4.74-0.41 1.5-0.63 3.06-0.98 4.59-0.2 0.88-0.61 1.09-1.5 0.93-1.26-0.23-2.52-0.44-3.79-0.6-0.68-0.09-0.97-0.4-0.98-1.07z"
              />
              <path
                fill="#f2f2f2"
                d="m1414.1 1484.9c0 0.68 0.01 1.37 0 2.05-0.02 0.89-0.29 1.16-1.18 1.22-1.33 0.09-2.69 0.09-3.99 0.34-1.7 0.31-3.42 0.66-5.03 1.26-2.35 0.89-4.66 1.94-6.89 3.09-1.28 0.65-2.4 1.6-3.56 2.47-0.74 0.56-1.28 0.5-1.85-0.25-0.81-1.06-1.67-2.07-2.55-3.08-0.51-0.59-0.51-1.18 0.1-1.58 2.07-1.35 4.09-2.77 6.22-4.02 1.26-0.74 2.67-1.23 4.03-1.8 0.81-0.34 1.65-0.61 2.47-0.88 0.67-0.22 1.34-0.44 2.03-0.59 1.89-0.41 3.77-0.85 5.68-1.14 1.23-0.19 2.5-0.16 3.74-0.21 0.58-0.02 0.78 0.37 0.78 0.9z"
              />
              <path
                fill="#f2f2f2"
                d="m1418 1484.8c0-0.71 0.01-1.43 0-2.14-0.01-0.64 0.26-0.98 0.92-0.92 1.73 0.16 3.44 0.34 5.17 0.51 0.23 0.02 0.45 0.11 0.67 0.12 1.92 0.11 3.72 0.67 5.5 1.35 1.85 0.71 3.74 1.31 5.5 2.21 1.86 0.95 3.58 2.17 5.35 3.29 0.58 0.36 1.12 0.78 1.68 1.17 0.66 0.46 0.68 0.96 0.16 1.56-0.88 1.03-1.74 2.09-2.57 3.16-0.52 0.67-1.08 0.76-1.73 0.22-1.9-1.59-3.99-2.91-6.25-3.93-1.73-0.78-3.49-1.52-5.32-2.04-2.4-0.68-4.83-1.28-7.37-1.23-1.54 0.04-1.7-0.16-1.7-1.72v-1.63z"
              />
              <path
                fill="#f2f2f2"
                d="m1444.8 1521.4c-0.75 0.07-1-0.26-1.14-1.01-0.29-1.48-0.7-2.96-1.2-4.39-0.43-1.24-0.94-2.49-1.62-3.61-0.8-1.32-1.79-2.54-2.75-3.75-0.55-0.68-1.23-1.26-1.83-1.91-0.43-0.46-0.19-0.92 0.14-1.3 0.91-1.08 1.85-2.14 2.78-3.22 0.47-0.54 0.96-0.57 1.45-0.06 2.41 2.46 4.7 5.02 6.25 8.14 0.66 1.33 1.37 2.66 1.89 4.05 0.43 1.16 0.61 2.4 0.9 3.61 0.09 0.39 0.14 0.78 0.25 1.17 0.32 1.05-0.16 1.81-1.29 1.94-1.27 0.14-2.55 0.23-3.82 0.34z"
              />
              <path
                fill="#f2f2f2"
                d="m1387.2 1521.4c-1.3-0.12-2.61-0.23-3.91-0.38-0.75-0.09-1.11-0.62-1.06-1.32 0.14-1.96 0.59-3.86 1.37-5.67 0.59-1.38 0.96-2.88 1.75-4.12 1.3-2.05 2.83-3.96 4.31-5.89 0.51-0.68 1.16-1.26 1.74-1.88 0.47-0.49 0.94-0.48 1.38 0.04 0.94 1.1 1.9 2.18 2.81 3.3 0.42 0.51 0.39 0.96-0.14 1.48-1.95 1.88-3.65 4-4.84 6.44-1.11 2.25-1.95 4.63-2.3 7.15-0.1 0.72-0.5 0.89-1.13 0.86h0.01z"
              />
              <path
                fill="#f2f2f2"
                d="m1414.1 1495.2c0 0.68-0.01 1.37 0 2.05 0.02 0.77-0.27 1.15-1.1 1.16-2.57 0.01-5.06 0.61-7.39 1.54-1.82 0.73-3.47 1.88-5.16 2.9-0.93 0.56-1.71 0.48-2.39-0.36-0.77-0.96-1.53-1.9-2.34-2.83-0.45-0.52-0.35-0.99 0.14-1.31 1.86-1.24 3.64-2.66 5.65-3.59 3.53-1.62 7.28-2.62 11.21-2.75 1.16-0.04 1.37 0.17 1.38 1.3v1.88z"
              />
              <path
                fill="#f2f2f2"
                d="m1420.2 1492.1c2.94 0.28 6.22 0.97 9.38 2.32 2.37 1.01 4.43 2.47 6.55 3.87 0.61 0.41 0.69 0.96 0.22 1.52-0.83 1.01-1.68 2-2.55 2.97-0.49 0.56-1.35 0.63-2.03 0.21-1.13-0.71-2.19-1.54-3.38-2.11-1.39-0.67-2.85-1.27-4.34-1.64-1.67-0.42-3.41-0.56-5.13-0.8-0.58-0.08-0.89-0.35-0.9-0.93 0-1.51-0.02-3.02 0.01-4.53 0.02-0.85 0.34-0.99 2.16-0.89z"
              />
              <path
                fill="#f2f2f2"
                d="m1396 1545c-2.79-0.51-5.59-0.95-8.35-1.55-1.56-0.34-3.07-0.95-4.6-1.46-0.79-0.26-0.91-0.78-0.53-1.53 0.48-0.98 0.9-1.99 1.28-3.01 0.47-1.25 1.11-1.93 2.37-1.08 0.76 0.51 1.78 0.73 2.72 0.9 2.29 0.39 4.59 0.7 6.9 1 1.04 0.14 1.65 0.81 1.6 1.85-0.04 1.14-0.01 2.27-0.04 3.42-0.02 0.97-0.36 1.28-1.3 1.26l-0.04 0.21z"
              />
              <path
                fill="#f2f2f2"
                d="m1434.6 1541.6c0-0.51 0.01-1.03 0-1.54-0.04-1.15 0.53-1.74 1.66-1.88 2.3-0.29 4.62-0.57 6.9-1.01 1.06-0.2 2.05-0.74 3.07-1.15 0.54-0.21 1.03-0.23 1.31 0.36 0.46 0.96 0.87 1.96 1.3 2.94 0.17 0.39 0.33 0.77 0.54 1.13 0.41 0.68 0.25 1.2-0.51 1.45-1.93 0.64-3.84 1.38-5.81 1.88-1.56 0.39-3.19 0.51-4.8 0.72-0.82 0.11-1.64 0.17-2.47 0.21-0.88 0.04-1.19-0.26-1.23-1.14-0.01-0.34 0.02-0.68 0.02-1.03v-0.94z"
              />
              <path
                fill="#f2f2f2"
                d="m1414.1 1505.3v1.96c0 0.58-0.29 0.91-0.88 0.94-2.53 0.15-4.81 1.02-6.84 2.5-0.63 0.46-1.11 0.33-1.55-0.19-0.88-1.03-1.75-2.08-2.6-3.14-0.39-0.48-0.24-0.96 0.25-1.23 1.77-0.98 3.49-2.14 5.37-2.82 1.65-0.6 3.49-0.67 5.25-0.93 0.68-0.1 1 0.28 0.99 0.96v1.96z"
              />
              <path
                fill="#f2f2f2"
                d="m1418 1505.2v-1.97c0-0.56 0.26-0.88 0.83-0.83 1.12 0.11 2.26 0.19 3.36 0.43 1.23 0.27 2.47 0.63 3.64 1.11 1.01 0.42 1.98 1.01 2.85 1.66 1.59 1.18 1.55 1.22 0.26 2.76-0.55 0.66-1.06 1.34-1.58 2-0.58 0.73-0.95 0.8-1.71 0.29-1.99-1.33-4.14-2.24-6.55-2.4-0.83-0.06-1.16-0.46-1.11-1.27 0.04-0.6 0-1.2 0-1.8z"
              />
              <path
                fill="#f2f2f2"
                d="m1416.3 1555h-3.5c-1.25 0-1.69-0.45-1.67-1.67 0.02-1.06-0.01-2.1-0.01-3.16 0-1.13 0.38-1.43 1.51-1.41 2.27 0.04 4.54 0.05 6.82 0 1.33-0.03 1.7 0.27 1.68 1.58-0.02 1.16-0.01 2.32 0 3.49 0 0.93-0.2 1.16-1.15 1.17-1.23 0.01-2.45 0-3.67 0z"
              />
              <path
                fill="#f2f2f2"
                d="m1434.6 1551.8c0-0.68-0.01-1.37 0-2.05 0.02-0.64 0.36-0.94 1.02-1.01 2.04-0.19 4.07-0.43 6.1-0.68 1.26-0.16 1.4-0.06 1.65 1.16 0.24 1.17 0.43 2.35 0.78 3.49 0.26 0.84-0.12 1.22-0.76 1.43-0.78 0.25-1.6 0.46-2.41 0.53-1.59 0.16-3.18 0.22-4.78 0.29-1.17 0.05-1.64-0.46-1.6-1.63 0.01-0.51 0-1.03 0-1.54z"
              />
              <path
                fill="#f2f2f2"
                d="m1397.4 1551.9v1.7c0.01 0.88-0.51 1.5-1.4 1.42-2.48-0.22-4.96-0.51-7.44-0.79-0.55-0.06-0.81-0.43-0.7-0.96 0.29-1.53 0.57-3.07 0.93-4.58 0.06-0.26 0.56-0.58 0.85-0.58 0.78 0.03 1.57 0.26 2.35 0.34 1.41 0.14 2.82 0.26 4.24 0.35 0.97 0.06 1.2 0.26 1.21 1.23v1.88h-0.05z"
              />
              <path
                fill="#f2f2f2"
                d="m1439.3 1518.4c-0.31 0.24-0.58 0.6-0.93 0.71-1.1 0.34-2.24 0.56-3.35 0.86-0.81 0.22-1.61-0.17-1.93-0.96-0.68-1.66-1.52-3.22-2.94-4.38-0.45-0.37-0.53-0.81-0.1-1.33 0.86-1.03 1.65-2.1 2.47-3.14 0.51-0.66 0.92-0.65 1.53-0.06 2.14 2.05 3.67 4.52 4.86 7.21 0.12 0.29 0.18 0.59 0.27 0.89l0.11 0.21z"
              />
              <path
                fill="#f2f2f2"
                d="m1392.8 1518.3c0.42-1.02 0.71-1.85 1.1-2.63 1.06-2.16 2.57-3.99 4.28-5.68 0.51-0.5 1.01-0.4 1.4 0.06 0.87 1.01 1.68 2.07 2.52 3.1 0.4 0.49 0.32 0.98-0.11 1.37-1.42 1.28-2.41 2.82-3.08 4.61-0.24 0.65-1.14 0.96-1.82 0.77-1.11-0.31-2.24-0.53-3.34-0.88-0.36-0.11-0.64-0.47-0.96-0.73z"
              />
              <path
                fill="#f2f2f2"
                d="m1416 1528h13.08c1.33 0 1.45 0.12 1.45 1.47v3.67c0 0.98-0.24 1.23-1.19 1.23h-26.59c-0.98 0-1.23-0.23-1.23-1.2v-3.93c0-1.11 0.16-1.25 1.31-1.25h13.18z"
              />
              <path
                fill="#f2f2f2"
                d="m1416 1544.7h-13.25c-1.06 0-1.19-0.12-1.19-1.17v-3.76c0-1.08 0.24-1.3 1.31-1.3 8.29 0 16.58 0 24.87 0.01 0.54 0 1.08-0.01 1.63 0 0.96 0.01 1.2 0.25 1.2 1.23v3.84c0 0.98-0.18 1.15-1.15 1.15z"
              />
              <path
                fill="#f2f2f2"
                d="m1430.6 1551.9v2.14c0 0.65-0.29 1.01-0.98 0.99-0.94-0.02-1.88 0.01-2.82 0-0.96-0.01-1.44-0.56-1.43-1.49 0.01-1.11 0-2.22 0-3.33s0.37-1.48 1.5-1.41c0.73 0.04 1.47 0.01 2.2 0 1.37-0.02 1.54 0.14 1.53 1.48v1.63z"
              />
              <path
                fill="#f2f2f2"
                d="m1401.5 1551.9v-2.05c0-0.69 0.36-1.06 1.06-1.06h2.97c0.66 0 1.03 0.35 1.05 0.98 0.04 1.4 0.06 2.79 0 4.19-0.03 0.71-0.64 1.01-1.25 1.05-0.96 0.06-1.94 0-2.91 0.01-0.61 0-0.89-0.32-0.91-0.89-0.02-0.74 0-1.48 0-2.22h-0.01z"
              />
            </g>
          </g>
          <g id="circle-election-elected" opacity="0.8" fill="none">
            <circle
              cx="1615.8"
              cy="1043.1"
              r="57.26"
              fill="url(#linear-gradient)"
            />
          </g>
        </g>
        <g id="content" :class="interactiveClasses" fill="white" stroke="white">
          <g id="ständerat" :class="{ hidden: disableBottomRight }">
            <text
              :font-size="smallTextSize"
              y="1593"
              x="1820"
              text-anchor="middle"
            >
              {{ bottomRightLabel }}
            </text>
          </g>
          <g id="nationalrat" :class="{ hidden: disableBottomRight }">
            <text
              :font-size="smallTextSize"
              y="1593"
              x="1415"
              text-anchor="middle"
            >
              {{ bottomLeftLabel }}
            </text>
          </g>
          <g id="bundesgericht" :class="{ hidden: disableTopRight }">
            <line
              stroke-width="2px"
              stroke-miterlimit="10"
              x1="1915.8"
              x2="1786.6"
              y1="1030.4"
              y2="1030.4"
            />
            <text
              :font-size="bigTextSize"
              font-weight="700"
              y="1020"
              x="1845"
              text-anchor="middle"
            >
              {{ topRightLabel }}
            </text>
          </g>
          <g id="bundesrat" :class="{ hidden: disableTopLeft }">
            <line
              stroke-width="2px"
              stroke-miterlimit="10"
              x1="1455"
              x2="1325.8"
              y1="1030.4"
              y2="1030.4"
            />
            <text
              :font-size="bigTextSize"
              font-weight="700"
              y="1020"
              x="1395"
              text-anchor="middle"
            >
              {{ topLeftLabel }}
            </text>
          </g>
          <g id="parlament" :class="{ hidden: disableMiddle }">
            <line
              stroke-width="2px"
              stroke-miterlimit="10"
              x1="1680.8"
              x2="1551.6"
              y1="1331.4"
              y2="1331.4"
            />
            <text
              :font-size="bigTextSize"
              font-weight="700"
              y="1320"
              x="1625"
              text-anchor="middle"
            >
              {{ middleLabel }}
            </text>
          </g>
          <g id="volk">
            <text
              :font-size="bigTextSize"
              font-weight="700"
              y="1790"
              x="1615"
              text-anchor="middle"
            >
              {{ bottomLabel }}
            </text>
            <line
              stroke-width="2px"
              stroke-miterlimit="10"
              x1="1681.4"
              x2="1552.2"
              y1="1798.7"
              y2="1798.7"
            />
          </g>
        </g>
        <g id="bund" fill="white" stroke="white">
          <text
            :font-size="bigTextSize"
            :class="boldTopLabel ? 'font-bold' : ''"
            y="755"
            x="1615"
            text-anchor="middle"
          >
            <tspan>{{ topLabel }}</tspan>
          </text>
          <text
            :font-size="smallTextSize"
            y="765"
            x="1615"
            text-anchor="middle"
          >
            <tspan :dy="smallLineHeight">{{ topSubLabel }}</tspan>
          </text>
        </g>
        <g id="highlights" :class="interactiveClasses" :fill="highlightsColor">
          <polygon
            id="highlight-arrow-L"
            opacity="0.05"
            points="2100.3 1604.4 1845.5 1819.3 1616.7 1540.8 1386.5 1817 1133.2 1605 1616.8 1039.7"
          />
          <polygon
            id="highlight-arrow-S"
            class="clickable"
            :class="{ hidden: disableMiddle }"
            @click="$emit('menu-click', 'middle')"
            @touchend="handleTouchend('middle')"
            points="2023.4 1593.1 1825.5 1759.8 1616.9 1506.9 1406.6 1757.5 1208.7 1588 1616.8 1102.7"
          />
          <polygon
            id="highlight-bottom-left-S"
            class="clickable"
            :class="{ hidden: disableBottomLeft }"
            @click="$emit('menu-click', 'bottom-left')"
            @touchend="handleTouchend('bottom-left')"
            points="1395.4 1773.4 1182.2 1594.8 1408.5 1325 1587 1539.8"
          />
          <polygon
            id="highlight-bottom-right-S"
            class="clickable"
            :class="{ hidden: disableBottomRight }"
            @click="$emit('menu-click', 'bottom-right')"
            @touchend="handleTouchend('bottom-right')"
            points="1837.4 1773.4 2050.6 1594.8 1824.4 1325 1645.8 1539.8"
          />
          <polygon
            id="highlight-top-right-L"
            opacity="0.05"
            points="1827.7 1286 2091.1 967.51 1849.6 763.41 1616.8 1039.8"
          />
          <polygon
            id="highlight-top-right-S"
            class="clickable"
            :class="{ hidden: disableTopRight }"
            @click="$emit('menu-click', 'top-right')"
            @touchend="handleTouchend('top-right')"
            points="1821.9 1253.4 2043.2 985.93 1837.8 812.37 1646.9 1040.8"
          />
          <polygon
            id="highlight-top-left-L"
            opacity="0.05"
            points="1406.6 1285.7 1143.9 966.51 1385.4 762.41 1616.8 1039.7"
          />
          <polygon
            id="highlight-top-left-S"
            class="clickable"
            :class="{ hidden: disableTopLeft }"
            @click="$emit('menu-click', 'top-left')"
            @touchend="handleTouchend('top-left')"
            points="1413.2 1252.4 1191.8 984.93 1397.2 811.37 1588.2 1039.8"
          />
        </g>
        <g @click="$emit('menu-click', 'bottom')" class="zoom">
          <path
            :class="interactiveClasses"
            :fill="highlightsColor"
            d="m 1617,1574 188.14161,225.2135 -189.19958,157.6848 -188.83567,-157.352 z"
          />
          <g
            id="button-elections"
            :fill="bottomCircleColor"
            stroke="white"
            stroke-miterlimit="10"
          >
            <circle
              id="circle-elections-outer"
              stroke-width="6px"
              cx="1616.8"
              cy="1960.6"
              r="116"
            />
            <circle
              id="circle-elections-inner"
              stroke-width="2px"
              cx="1616.8"
              cy="1960.1"
              r="62.36"
            />
          </g>
        </g>
      </g>
      <filter id="outline">
        <feMorphology
          in="SourceAlpha"
          result="expanded"
          operator="dilate"
          radius="1"
        />
        <feFlood flood-color="white" />
        <feComposite in2="expanded" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <image
        :xlink:href="flagUrl"
        :src="flagUrl"
        width="170"
        height="170"
        x="395"
        y="30"
        :filter="constituencyLevel === 'cantonal' ? 'url(#outline)' : null"
      />
    </svg>
    <div
      id="government-menu-informative-text"
      :class="['px-6', informativeClasses]"
      :style="textStyle"
    >
      <information-paragraph
        :class="{
          'cursor-pointer': !informativeContentDisableClick
        }"
        @click="
          !informativeContentDisableClick && $emit('menu-click', 'information')
        "
        >{{ informativeContent }}</information-paragraph
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InformationParagraph from "@/components/nav/InformationParagraph.vue";
import { mapMutations } from "vuex";
import IsMobileMixin from "@/utils/IsMobileMixin";

export default {
  name: "GovernmentMenu",
  // By default, the text inside of the svg resizes along with the svg.
  // All the code below is there to keep the size of the text constant.
  // If you find a cleaner solution please remove this monstrosity.
  data() {
    return {
      svgRatio: 1,
      resizeTimeout: 0,
      svgElement: null,
      textStyle: {},
      touchStartpoint: { x: 0, y: 0 },
      touchEndpoint: { x: 0, y: 0 },
      isSwitching: true
    };
  },
  components: {
    InformationParagraph
  },
  mixins: [IsMobileMixin],
  created() {
    if (this.levelSwitchBus) {
      this.levelSwitchBus.$on("is-switching", () => {
        this.isSwitching = true;
      });
      this.levelSwitchBus.$on("done-switching", () => {
        this.isSwitching = false;
      });
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.svgElement = this.$el.querySelector("svg.menu");
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapMutations("viewState", ["changeConstituencyLevel"]),
    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.onResize, 100);
    },
    onResize() {
      const rect = this.svgElement.getBoundingClientRect();
      const viewBox = this.svgElement.getAttribute("viewBox").split(" ");
      this.svgRatio = Math.min(
        rect.width / parseFloat(viewBox[2]),
        rect.height / parseFloat(viewBox[3])
      );

      const containerRatio = rect.width / rect.height;
      const menuRatio = parseFloat(viewBox[2]) / parseFloat(viewBox[3]);

      // Container too large
      if (containerRatio >= menuRatio) {
        const width = rect.height * menuRatio;
        const offsetX = (rect.width - width) / 2;
        this.textStyle = {
          top: "20%",
          left: `${offsetX}px`,
          width: `${width}px`,
          height: "60%"
        };
      } else {
        const height = (rect.width / menuRatio) * 0.6;
        const offsetY = (rect.height - height) / 2;
        this.textStyle = {
          top: `${offsetY}px`,
          left: 0,
          width: "100%",
          height: `${height}px`
        };
      }
    },
    handleTouchend(position) {
      setTimeout(() => {
        if (!this.isSwitching) {
          this.$emit("menu-click", position);
        }
      }, 20);
    },
    onTouchstart(e) {
      this.levelSwitchBus.$emit("touch-start", e);
    },
    onTouchmove(e) {
      this.levelSwitchBus.$emit("touch-move", e);
    },
    onTouchend() {
      this.levelSwitchBus.$emit("touch-end");
    }
  },
  computed: {
    bigTextRem() {
      return this.isMobileScreen ? 0.9625 : 1.25;
    },
    bigTextValue() {
      return this.bigTextRem / this.svgRatio;
    },
    bigTextSize() {
      return `${this.bigTextValue}rem`;
    },
    smallTextRem() {
      return this.isMobileScreen ? 0.7375 : 1;
    },
    smallTextValue() {
      return this.smallTextRem / this.svgRatio;
    },
    smallTextSize() {
      return `${this.smallTextValue}rem`;
    },
    smallLineHeight() {
      // Cannot use rem as dx/dy property in some web browsers
      const pxToRem = parseInt(
        getComputedStyle(document.documentElement).fontSize
      );
      return `${pxToRem * this.smallTextValue * 1.2}px`;
    },
    interactiveClasses() {
      return {
        "force-hide": !!this.informativeContent
      };
    },
    informativeClasses() {
      return {
        "force-hide": !this.informativeContent
      };
    },
    disableTopLeft() {
      return !this.topLeftLabel;
    },
    disableTopRight() {
      return !this.topRightLabel;
    },
    disableMiddle() {
      return !this.middleLabel;
    },
    disableBottomLeft() {
      return !this.bottomLeftLabel;
    },
    disableBottomRight() {
      return !this.bottomRightLabel;
    }
  },
  props: {
    topLabel: {
      required: true,
      type: String
    },
    topSubLabel: {
      default: "",
      type: String
    },
    topLeftLabel: {
      type: String
    },
    topRightLabel: {
      type: String
    },
    middleLabel: {
      type: String
    },
    bottomLeftLabel: {
      type: String
    },
    bottomRightLabel: {
      type: String
    },
    bottomLabel: {
      required: true,
      type: String
    },
    flagUrl: {
      required: true,
      type: String
    },
    constituencyLevel: {
      required: true,
      type: String
    },
    bottomCircleColor: {
      default: "#77d3cc",
      type: String
    },
    highlightsColor: {
      default: "#f2f2f2",
      type: String
    },
    informativeContent: {
      default: "",
      type: String
    },
    levelSwitchBus: {
      type: Vue,
      required: true
    },
    boldTopLabel: {
      type: Boolean,
      default: true
    },
    informativeContentDisableClick: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.force-hide {
  display: none !important;
}

#government-menu-informative-text {
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: space-around;
}

.clickable {
  opacity: 0;
}

.clickable:hover {
  cursor: pointer;
  opacity: 0.05;
}

.zoom path {
  opacity: 0;
}

.zoom:hover {
  cursor: pointer;
}

.zoom:hover path {
  opacity: 0.05;
}

.zoom #circle-elections-outer,
.zoom #circle-elections-inner {
  transition: r 0.2s;
}

.zoom:hover #circle-elections-outer {
  r: 128px;
}

.zoom:hover #circle-elections-inner {
  r: 68px;
}
</style>
